import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-colapsable',
  templateUrl: './colapsable.component.html',
  styleUrls: ['./colapsable.component.sass'],
})
export class ColapsableComponent implements OnInit {
  @Input() title: string;
  @Input() expanded = true;
  @Input() theme: string;
  @Input() item: any;
  @Input() info: string;
  @Input() mostrarInfo = false;
  @Output() $expandedChange = new EventEmitter();
  constructor() {}

  ngOnInit() {}

  onExpandedChange() {
    this.$expandedChange.emit(this.item);
  }
}
